import React from "react";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import { navLinks } from "./GreenApiPage";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import ActionButton from "../../components/button/ActionButton";
import AnyField from "../../components/fields/AnyField";
import Tooltip from "@material-ui/core/Tooltip";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useVendorInstances from "./hooks/useVendorInstances";

const useStyles = makeStyles(theme => ({
    btn: {
        backgroundColor: "#f0f0f0",
        border: "none",
        cursor: "pointer",
        padding: "5px",
        borderRadius: "4px",
        transition: "background-color 0.3s ease",

        "&:hover": {
            backgroundColor: "#d9d9d9",
        },
    }
}));

export default function InstancesServiceWhatsappPage() {
    const {t} = useTranslation();
    const classes = useStyles();

    const {
        getTableData,
        refreshTable,
        isOpen,
        rowData,
        openMenuDialog,
        isOpenEditDialog,
        handleCloseEditDialog,
        handleChange,
        editInstance,
        updateStatus,
        restartInstance,
        logoutInstance,
        getQR,
        isOpenDeleteInstanceDialog,
        deleteInstanceDialog,
        deleteInstance,
        isOpenCreate,
        isOpenCreateDialog,
        newInstance,
        handleChangeCreate,
        createInstance,
        disableBtn,
        updateAllInstances,
        errorDialog,
        successDialog,
        errorMessage,
    } = useVendorInstances('whatsappService');

    const columnData = [
        {
            id: 'action', numeric: false, disableSorting: true, label: 'Action',
            processValue: () => (
                <button className={classes.btn}>{t("Settings")}</button>
            ),
        },
        {id: 'phone', numeric: false, disableSorting: true, label: 'Phone'},
        {id: 'name', numeric: false, disableSorting: true, label: 'Name'},
        {id: 'instanceState', numeric: false, disableSorting: true, label: 'State'},
        {id: 'instanceId', numeric: false, disableSorting: true, label: 'instanceId'},
        {
            id: 'dateCreate',
            numeric: false,
            disableSorting: true,
            label: 'Date created',
            processValue: (val) => moment(val).format('DD.MM.YYYY'),
        },
        {id: 'queue', numeric: false, disableSorting: true, label: 'Queue'},
        {id: 'minPauseMessage', numeric: false, disableSorting: true, label: 'Min pause message'},
        {id: 'maxPauseMessage', numeric: false, disableSorting: true, label: 'Max pause message'},
    ];

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                <ActionButton onClick={isOpenCreateDialog}>{t("Create instance")}</ActionButton>
                <ActionButton onClick={updateAllInstances}>{t("Update statuses all instances")}</ActionButton>
            </LeftBar>
            <Content title={t("Service instances - WhatsApp")}>
                <DataTable
                    columnData={columnData}
                    dataFunc={getTableData}
                    selector={false}
                    onClick={openMenuDialog}
                    refresh={refreshTable}
                    pagination={true}
                />
            </Content>

            <Dialog open={isOpen} onClose={openMenuDialog}>
                <DialogTitle id="dialog-title">{t("Settings")} {rowData.phone}</DialogTitle>
                <div style={{padding: "0 24px 24px"}}>
                    <div>Актуальный статус: { rowData.instanceState }</div>
                    <ActionButton onClick={updateStatus}>{t("Update status")}</ActionButton>
                    <ActionButton onClick={restartInstance}>{t("Reboot")}</ActionButton>
                    <ActionButton onClick={logoutInstance} disabled={rowData.instanceState === "Не авторизован"}>{t("Logout")}</ActionButton>
                    <ActionButton onClick={handleCloseEditDialog}>{t("Edit")}</ActionButton>
                    <ActionButton onClick={deleteInstanceDialog}>{t("Delete")}</ActionButton>
                    <Tooltip title="Кнопка неактивна если пользователь авторизован">
                        <div>
                            <ActionButton onClick={getQR} disabled={rowData.instanceState !== "Не авторизован"}>
                                {t("Get QR")}
                            </ActionButton>
                        </div>
                    </Tooltip>
                </div>
            </Dialog>

            <Dialog
                open={isOpenEditDialog}
                onClose={handleCloseEditDialog}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                fullWidth
            >
                <DialogTitle id="dialog-title">{t("Edit instance")}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <AnyField
                                id="host"
                                label={t("Host")}
                                value={(rowData?.host) ? rowData.host : ''}
                                onChange={handleChange('host')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="Phone"
                                label={t("Phone")}
                                value={(rowData?.phone) ? rowData.phone : ''}
                                onChange={handleChange('phone')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="name"
                                label={t("Name")}
                                value={(rowData?.name) ? rowData.name : ''}
                                onChange={handleChange('name')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="minPauseMessage"
                                label={t("Min pause message")}
                                value={(rowData?.minPauseMessage) ? rowData.minPauseMessage : ''}
                                onChange={handleChange('minPauseMessage')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <AnyField
                                id="mediaHost"
                                label={t("Media Host")}
                                value={(rowData?.mediaHost) ? rowData.mediaHost : ''}
                                onChange={handleChange('mediaHost')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="instanceId"
                                label={t("Instance Id")}
                                value={(rowData?.instanceId) ? rowData.instanceId : ''}
                                onChange={handleChange('instanceId')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="queue"
                                label={t("Queue")}
                                value={(rowData?.queue) ? rowData.queue : ''}
                                placeholder={"a–Z, 0-9, \".\", \"_\", без пробелов"}
                                onChange={handleChange('queue')}
                                disabled={isOpenEditDialog}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="maxPauseMessage"
                                label={t("Max pause message")}
                                value={(rowData?.maxPauseMessage) ? rowData.maxPauseMessage : ''}
                                onChange={handleChange('maxPauseMessage')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AnyField
                                id="apiTokenInstance"
                                label={t("Api token instance")}
                                value={(rowData?.apiTokenInstance) ? rowData.apiTokenInstance : ''}
                                onChange={handleChange('apiTokenInstance')}
                                visible={true}
                                style={{ width: "90%" }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={editInstance} color="primary">OK</Button>
                    <Button onClick={handleCloseEditDialog} color="primary">Отмена</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isOpenCreate}
                onClose={isOpenCreateDialog}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                fullWidth
            >
                <DialogTitle id="dialog-title">{t("Create instance")}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <AnyField
                                id="host"
                                label={t("Host")}
                                value={(newInstance?.host) ? newInstance.host : ''}
                                onChange={handleChangeCreate('host')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="Phone"
                                label={t("Phone")}
                                value={(newInstance?.phone) ? newInstance.phone : ''}
                                onChange={handleChangeCreate('phone')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="name"
                                label={t("Name")}
                                value={(newInstance?.name) ? newInstance.name : ''}
                                onChange={handleChangeCreate('name')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="minPauseMessage"
                                label={t("Min pause message")}
                                value={(newInstance?.minPauseMessage) ? newInstance.minPauseMessage : ''}
                                onChange={handleChangeCreate('minPauseMessage')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <AnyField
                                id="mediaHost"
                                label={t("Media Host")}
                                value={(newInstance?.mediaHost) ? newInstance.mediaHost : ''}
                                onChange={handleChangeCreate('mediaHost')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="instanceId"
                                label={t("instanceId")}
                                value={(newInstance?.instanceId) ? newInstance.instanceId : ''}
                                onChange={handleChangeCreate('instanceId')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="queue"
                                label={t("Queue")}
                                value={(newInstance?.queue) ? newInstance.queue : ''}
                                placeholder={"a–Z, 0-9, \".\", \"_\", без пробелов"}
                                onChange={handleChangeCreate('queue')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="maxPauseMessage"
                                label={t("Max pause message")}
                                value={(newInstance?.maxPauseMessage) ? newInstance.maxPauseMessage : ''}
                                onChange={handleChangeCreate('maxPauseMessage')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AnyField
                                id="apiTokenInstance"
                                label={t("Api token instance")}
                                value={(newInstance?.apiTokenInstance) ? newInstance.apiTokenInstance : ''}
                                onChange={handleChangeCreate('apiTokenInstance')}
                                visible={true}
                                required={true}
                                style={{ width: "90%" }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={createInstance} disabled={disableBtn} color="primary">Создать</Button>
                    <Button onClick={isOpenCreateDialog} color="primary">Отмена</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={successDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{t("Success")}</DialogTitle>
            </Dialog>

            <Dialog open={errorDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{errorMessage}</DialogTitle>
            </Dialog>

            <Dialog open={isOpenDeleteInstanceDialog}>
                <div style={{padding: "0 80px 0 80px"}}>
                    <DialogTitle>{t("Delete instance")}</DialogTitle>
                    <DialogActions>
                        <ActionButton style={{padding: "0 20px 0 20px"}} onClick={deleteInstance} color="secondary">{t("Confirm")}</ActionButton>
                        <ActionButton style={{padding: "0 10px 0 10px"}} onClick={deleteInstanceDialog} color="secondary">{t("Cancel")}</ActionButton>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    );
}
